import { Outlet } from 'react-router-dom'
import './PublicLayout.css'

function PublicLayout() {
  return (
    <div className="public-layout">
      <Outlet />
    </div>
  )
}

export default PublicLayout
